// PopuBajaDefinitiva.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonPopup } from "../ui"; // ajusta la ruta si hace falta

interface PopuBajaDefinitivaProps {
    onClose?: () => void;
    redirectTo?: string;
}

const PopuBajaDefinitiva: React.FC<PopuBajaDefinitivaProps> = ({ onClose, redirectTo = "/backoffice", }) => {
    const [isClosing, setIsClosing] = useState(false);
    const navigate = useNavigate();
    navigate(redirectTo);

    const handleClose = () => {
        // Inicia animación de salida
        setIsClosing(true);

        // Espera a que termine la animación y luego navega
        setTimeout(() => {
            onClose?.();        // opcional: avisar al padre si se proporciona
            navigate("/");  // ← navega a /sing
        }, 500); // debe coincidir con la duración de fadeOut (0.5s en tu tailwind.config)
    };

    return (
        <div
            className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 ${isClosing ? "animate-fadeOut" : "animate-fadeIn"} p-4`} >

            <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
                <h2 className="text-2xl font-bold text-red-600 mb-4 animate-pulse">
                    Ha puesto en pausa su sucripción
                </h2>

                <p className="text-zinc-700 mb-4">
                    Su suscripción queda suspendida hasta que decida volver a reanudarla. Recuerde que el
                    tiempo de la suscripción también queda suspendido.
                </p>

                <p className="text-zinc-700 mb-2">
                    Para cualquier aclaración o asistencia adicional, puede ponerse en contacto con
                    el soporte técnico de <strong>LinkServs</strong> mediante un correo electrónico o
                    llamando al número de atención al cliente.
                </p>
                <p className="mb-2"><strong>¡¡Un fuerte abrazo!!</strong></p>

                <div className="text-sm text-zinc-600 mb-8 space-y-1">
                    <p>📧 <strong>Email:</strong> soporte@linkservs.com</p>
                    <p>☎️ <strong>Teléfono:</strong> +33 000 000 000</p>
                </div>

                <ButtonPopup
                    onClick={handleClose}
                    className="!bg-red-600 hover:!bg-red-700 text-white font-semibold px-6 py-2 rounded-lg shadow-md transition-all"
                >
                    Cerrar
                </ButtonPopup>
            </div>
        </div>
    );
};

export default PopuBajaDefinitiva;
